import { INavigationItem, IWithNavigationViewState } from "./interfaces";

function getNavigationItem(state: IWithNavigationViewState, itemId: string): INavigationItem {
  return state.views.navigation.items[itemId];
}

export function getNavigationItemBadge(state: IWithNavigationViewState, itemId: string): number {
  const item = getNavigationItem(state, itemId);
  // @ts-expect-error TS(2322): Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
  return (item && item.badge) || null;
}
